/* eslint-disable import/prefer-default-export */
import isNil from 'lodash/isNil'
import { SET_EVENT_VIDEO_AUDIO_CHANGED } from '../event-tracking/actions'
import { addNewRelicAction } from '../app/_newrelic'

export function watchVideoAudioChangeForNewRelicEvent ({ after }) {
  return after(SET_EVENT_VIDEO_AUDIO_CHANGED, async ({ action, state }) => {
    const { user } = state
    const anonymousUuid = user.getIn(['data', 'anonymousUuid'])
    const userUuid = user.getIn(['data', 'uuid'])
    const { payload: { lang, isLive, isInitial } } = action
    const newRelicData = {
      anonymousUuid,
      userUuid,
      selectedAudioTrack: lang,
      audioTrackChangeSuccess: !isNil(lang),
      isLive: isLive === true,
      isInitial: isInitial === true,
    }
    addNewRelicAction('VideoAudioChange', newRelicData)
  })
}
